import {
  useQuery,
  QueryFunctionContext,
  UseQueryOptions,
} from "@tanstack/react-query";

import { getNews as _getNews } from "api";
import { sliceQueryFunctionContext } from "utils";

const getNews = sliceQueryFunctionContext(
  (context: QueryFunctionContext<string[]>) => {
    const { queryKey } = context;
    const args: [string] = [queryKey[1]];
    return args;
  },
  _getNews
);

export function useNews(
  siteId: string,
  options?: UseQueryOptions<string[], unknown, string[], string[]>
) {
  const queryKey = ["news", siteId];

  return useQuery({
    queryKey,
    queryFn: getNews,
    ...options,
  });
}
